/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */

import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class GenealogyService {
    private genealogyUrl: string = environment.host + '/participant/';
    private organizationUrl: string = environment.host + '/organizationalUnit/';
    private volumeUrl: string = environment.host + '/plan/';
    private masterColumnsAndFiltersUrl: string = environment.host + '/compensation/analytics/metadata';
    private groupMetadataUrl: string = environment.host + '/participant/metadata';
    private genealogyReportUrl: string = environment.host + '/report/Genealogy';
    private directorReportUrl: string = environment.host + '/report/DirectorPromotionReports';
    private currentPeriodUrl: string = environment.host + '/currentperiod';
    private directorPromotionUrl: string = environment.host + '/participant/directorreport';
    private ahUrl: string = environment.host + '/AdvisorHistory';
    private ahReportUrl: string = environment.host + '/report/AdvisorHistory';
    public invokeCancelRequest: Observable<any>;
    public isCancelRequest: Subject<any>;

    constructor(private http: HttpClient) {
        this.isCancelRequest = new Subject<boolean>();
        this.invokeCancelRequest = this.isCancelRequest.asObservable();
    }

    public cancelRequest(val: any) {
        this.isCancelRequest.next(val);
    }

    public getVolumeCodes(planId: any) {
        const volumeUrl = this.volumeUrl + planId + '/volume-definition';
        return this.http.get(volumeUrl).toPromise();
    }

    public getGroupMetadata() {
        const groupMetadataUrl = this.groupMetadataUrl;
        return this.http.get(groupMetadataUrl).toPromise();
    }

    public loadMasterColumnsAndFilters() {
        return this.http.get(this.masterColumnsAndFiltersUrl).toPromise();
    }

    public getAllGenealogySavedReports() {
        const genealogyReportUrl = this.genealogyReportUrl;
        return this.http.get(genealogyReportUrl).toPromise();
    }

    public getGroupDetails(clientId: any, selectedGroup: any, homeMarket: any) {
        // /participant/1/genealogy?group=3&scope=homemarket
        const personalUrl = this.genealogyUrl + clientId + '/genealogy?group=' + selectedGroup + '&scope=' + homeMarket;
        return this.http.get(personalUrl).toPromise();
    }

    //genealogy distributor data in Hierarchical structure.
    public getGenealogyHierarchicalData(clientId: any, selectedGroup: any, homeMarket: any, payload: any, periodPosition: any, reportName: any) {
        const teamUrl = this.genealogyUrl + clientId + '/team?group=' + selectedGroup + '&scope=' + homeMarket + '&currentPeriod=' + periodPosition + '&reportName=' + reportName;

        return this.http.post(teamUrl, payload).pipe(
            map(response => response))
    }

    //genealogy organization data in Hierarchical structure.
    public getOrganizationHierarchicalData(organizationId: any, selectedGroup: any, homeMarket: any, payload: any, periodPosition: any, reportName: any) {
        const teamUrl = this.organizationUrl + organizationId + '/team?group=' + selectedGroup + '&scope=' + homeMarket + '&currentPeriod=' + periodPosition + '&reportName=' + reportName;

        return this.http.post(teamUrl, payload).pipe(
            map(response => response))
    }

    public getDirectorPromotionData() {
        return this.http.get((this.directorPromotionUrl).toString()).toPromise();
    }

    public getDefaultReportDetails() {
        return this.http.get((this.genealogyReportUrl).toString()).toPromise();
    }

    public getDirectorDefaultReportDetails() {
        return this.http.get((this.directorReportUrl).toString()).toPromise();
    }

    public getCurrentPeriod(regionCode: any) {
        if (regionCode) {
            return this.http.get(this.currentPeriodUrl + '?regionCode=' + regionCode).toPromise();
        } else {
            return this.http.get(this.currentPeriodUrl).toPromise();
        }
    }

    public getAHData(payload: any) {
        const url = this.ahUrl;
        return this.http.post(url, payload).pipe(map(response => response));
    }

    public getAHDefaultReportDetails() {
        return this.http.get((this.ahReportUrl).toString()).toPromise();
    }
}
